function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';

var Gap = function Gap(_ref) {
  var orientation = _ref.orientation,
      factor = _ref.factor,
      base = _ref.base,
      className = _ref.className;
  // 如果BrandProvider是osc，为4，否则为5
  var innerBase = base !== null && base !== void 0 ? base : 4;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: _defineProperty({}, orientation === 'horizontal' ? 'width' : 'height', factor * innerBase)
  });
};

var HorizontalGap = function HorizontalGap(_ref2) {
  var factor = _ref2.factor,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement(Gap, {
    className: className,
    orientation: "horizontal",
    factor: factor
  });
};

var VerticalGap = function VerticalGap(_ref3) {
  var factor = _ref3.factor,
      className = _ref3.className;
  return /*#__PURE__*/React.createElement(Gap, {
    className: className,
    orientation: "vertical",
    factor: factor
  });
};

var FlexFitGap = function FlexFitGap(_ref4) {
  var className = _ref4.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: {
      flex: 1
    }
  });
};

Gap.Horizontal = HorizontalGap;
Gap.Vertical = VerticalGap;
Gap.FlexFit = FlexFitGap;
export default Gap;
//# sourceMappingURL=index.js.map